import type { RootState } from "@/app/store";
import { MotivoNotificacao } from "@/contexts/laboratorio/motivoNotificacao/model/MotivoNotificacao";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface MotivoNotificacaoState {
  items: MotivoNotificacao[];
  synced: boolean;
}

const initialState: MotivoNotificacaoState = {
  items: [],
  synced: false,
};

const motivoNotificacaoSlice = createSlice({
  name: "MOTIVO_NOTIFICACAO",
  initialState,
  reducers: {
    sync: {
      reducer: (
        state,
        action: PayloadAction<{ items: MotivoNotificacao[] }>
      ) => {
        state.items = action.payload.items;
        state.synced = true;
      },
      prepare: (items: MotivoNotificacao[]) => ({
        payload: { items },
      }),
    },
  },
});

export const motivoNotificacaoAction = motivoNotificacaoSlice.actions;

export default motivoNotificacaoSlice.reducer;

export const getMotivosNotificacaoSynced = (state: RootState) =>
  state.motivoNotificacao.items;
